import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from 'src/app/store';
import { EChatEventName, EChatType } from '../../enums';
import { IChatMember, IChatListItem } from '../../models';
import { ChatDialogService } from '../../services/chat-dialog.service';
import { ChatEventsService } from '../../services/chat-events.service';
import { UserAccountType } from 'src/app/data-types/user-data';

export interface INewChannelDialogResult {
    status: 'create' | 'cancel';
    channelMembers?: IChatMember[];
    channelName?: string;
}

@UntilDestroy()
@Component({
    selector: 'app-new-channel-dialog',
    templateUrl: './new-channel-dialog.component.html',
    styleUrls: ['./new-channel-dialog.component.scss'],
})
export class NewChannelDialogComponent implements OnInit {
    channelName = new FormControl('');
    channelMembers: IChatMember[] = [];
    filteredUsers: IChatMember[];
    chats: IChatListItem[];
    user = this.store.selectForLocal('user');
    userDialogOpened = false;

    get canCreateChannel(): boolean {
        return this.channelName.value.trim().length > 0 && this.channelMembers.length > 0;
    }

    get selectedUserIds() {
        return this.channelMembers.map((u) => u.id);
    }

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            users: IChatMember[];
            chats: IChatListItem[];
        },
        public dialogRef: MatDialogRef<NewChannelDialogComponent>,
        public dialog: MatDialog,
        private store: Store,
        private chatEventsService: ChatEventsService,
        private chatDialogService: ChatDialogService
    ) {
        this.filteredUsers = data.users;
        this.chats = data.chats;
    }

    ngOnInit(): void {}

    async selectUserDialog() {
        const selectedUsers: IChatMember[] = (await this.chatDialogService.openUsersSelectorDlg(
            'many',
            'Apply',
            this.channelMembers,
            [UserAccountType.Admin],
            false
        )) as IChatMember[];

        if (!selectedUsers) return;

        this.channelMembers = selectedUsers;
    }

    createChannel() {
        const existChatId = this.channelExists();

        if (existChatId) {
            this.chatEventsService.emitEvent(EChatEventName.ChatSelected, { id: existChatId });
            this.dialogRef.close();
            return;
        }

        const currentUser: IChatMember = {
            id: this.user.id,
            firstname: this.user.contact.firstname,
            surname: this.user.contact.surname,
            avatarColour: this.user.avatarColour,
            accountType: this.user.accountType,
        };

        this.chatEventsService.emitEvent(EChatEventName.CreateChat, {
            mode: EChatType.Channel,
            members: [...this.channelMembers, currentUser],
            channelName: this.channelName.value.trim(),
        });

        this.dialogRef.close();
    }

    removeMember(memberForRemove, $event) {
        this.channelMembers = this.channelMembers.filter((m) => m.id !== memberForRemove.id);
        $event.stopPropagation();
    }

    private channelExists() {
        const selectedUserIdsHash = [...this.selectedUserIds, this.user.id].sort().join();

        const existsChat = this.chats.find((c) => {
            return (
                c.members
                    .map((m) => m.id)
                    .sort()
                    .join() === selectedUserIdsHash
            );
        });

        return existsChat ? existsChat.id : null;
    }
}
